// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetProjectsListMetaRequest,
  TGetProjectsListMetaModel,
  IMappers,
  TGetProjectsListMetaResponse,
  IGetProjectsListMetaResponse,
  IGetProjectsListMetaResponseError,
} from './types';

export const defaultConfig: TGetProjectsListMetaModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-constructors',
  pathApi: '/v1/get-projects-list-meta/',
} as TGetProjectsListMetaModel;

export function createGetProjectsListMetaModel(parameters: IGetProjectsListMetaRequest): TGetProjectsListMetaModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetProjectsListMetaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsListMetaRequest;
}

export async function fetchGetProjectsListMeta<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsListMetaOptions<TResponse200, TResponse400>): Promise<
  TGetProjectsListMetaResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetProjectsListMetaModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetProjectsListMetaResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetProjectsListMetaResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetProjectsListMetaResponse;
}
